"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ColorPalette;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function ColorOption(props) {
  var _useRadio = (0, _react2.useRadio)(props),
      getInputProps = _useRadio.getInputProps,
      getCheckboxProps = _useRadio.getCheckboxProps;

  var input = getInputProps();
  var checkbox = getCheckboxProps();
  return /*#__PURE__*/_react.default.createElement(_react2.Tooltip, {
    label: props.label,
    isDisabled: isTouchDevice()
  }, /*#__PURE__*/_react.default.createElement(_react2.Box, _extends({}, checkbox, {
    borderRadius: "full",
    p: 4,
    bg: props.color,
    as: "label",
    transition: "opacity 0.4s ease",
    cursor: "pointer",
    _checked: {
      boxShadow: "inset 0 0 0 2px black"
    },
    _hover: {
      boxShadow: "inset 0 0 0 2px black"
    },
    border: "1px",
    borderColor: "gray.200"
  }), /*#__PURE__*/_react.default.createElement("input", input)));
}

function ColorPalette(props) {
  var _useRadioGroup = (0, _react2.useRadioGroup)({
    name: "color",
    defaultValue: props.colors[0].color,
    onChange: props.onChange
  }),
      getRootProps = _useRadioGroup.getRootProps,
      getRadioProps = _useRadioGroup.getRadioProps;

  var group = getRootProps();
  return /*#__PURE__*/_react.default.createElement(_react2.SimpleGrid, _extends({}, group, {
    minChildWidth: "30px",
    spacing: 2
  }), props.colors.map(function (option) {
    var radio = getRadioProps({
      value: option.color
    });
    return /*#__PURE__*/_react.default.createElement(_react2.Box, {
      key: option.color,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/_react.default.createElement(ColorOption, _extends({
      color: option.color,
      label: option.name
    }, radio)));
  }));
}